module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"select_city":"Выберите город"},"en":{"select_city":"Select city"}}')
  delete Component.options._Ctor
}
